export default __webpack_public_path__ + "static/media/JocelynColm.9f0c6438.jpg";